import { FormikErrors } from "formik";
import { msgSubmissionInvalid } from "../pages/Requests/messages";

export default class ValidationError extends Error {
  private violations: FormikErrors<unknown>;

  constructor(violations: FormikErrors<unknown>, message?: string) {
    super(message || msgSubmissionInvalid);
    this.violations = violations;
  }
}
